<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row>
        <b-col
          cols="12"
          class="text-right"
          v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')"
        >
          <button
            class="btn btn-info"
            @click="initLeaveType"
            v-b-modal.modal-leaveType
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
        </b-col>
      </b-row>
      <b-row class="h-100">
        <b-col cols="12" class="h-100 pb-5">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-100">
              <v-client-table
                :data="tableData"
                :columns="columns"
                :options="options"
              >
                <template slot="h__IsNeedUpload">
                  <div style="text-align:center">
                    {{ t.t(dictEnum.LBL_IsNeedUpload) }}
                  </div>
                </template>
                <template slot="h__PayLeave">
                  <div style="text-align:center">
                    {{ t.t(dictEnum.LBL_IsPayLeave) }}
                  </div>
                </template>
                <template slot="h__DiscPay">
                  <div style="text-align:right">
                    {{ t.t(dictEnum.LBL_DiscPay) }}
                  </div>
                </template>
                <template slot="h__DaysAdv">
                  <div style="text-align:right">
                    {{ t.t(dictEnum.LBL_DaysAdv) }}
                  </div>
                </template>
                <template slot="Color" slot-scope="props">
                  <div
                    style="height: 20px"
                    :style="{
                      'background-color': props.row.Color
                    }"
                  ></div>
                </template>
                <template slot="IsNeedUpload" slot-scope="props">
                  <div style="text-align: center">
                    <b-form-checkbox
                      disabled
                      v-model="props.row.IsNeedUpload"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template slot="DaysAdv" slot-scope="props">
                  <div style="text-align: right">
                    {{ props.row.DaysAdv}}{{ t.t(dictEnum.LBL_Days) }}
                  </div>
                </template>
                <template slot="PayLeave" slot-scope="props">
                  <div style="text-align: center">
                    <b-form-checkbox
                      disabled
                      v-model="props.row.PayLeave"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template slot="DiscPay" slot-scope="props">
                  <div style="text-align: right">
                    {{ props.row.DiscPay | percent }}
                  </div>
                </template>

                <template slot="Action" slot-scope="props">
                  <div>
                    <font-awesome-icon
                      icon="edit"
                      style="cursor:pointer"
                      v-if="hasRight(Settings.Permission.Change)"
                      v-b-modal.modal-leaveType
                      @click="onEditLeaveType(props.row)"
                    />

                    <font-awesome-icon
                      icon="trash"
                      style="cursor:pointer"
                      v-if="
                        hasRight('AlwDel') &&
                          props.row.LeaveType !== annualLeaveKey &&
                          props.row.LeaveType !== compensationKey
                      "
                      @click="deleteLeaveType(props.row)"
                    />
                  </div>
                </template>
              </v-client-table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      id="modal-leaveType"
      :title="mode == 'new' ? t.t(dictEnum.LBL_Add) : t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddLeaveType"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_LeaveType) }}</span>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                maxlength="15"
                :readonly="mode === 'new' ? false : true"
                v-model="leaveType.LeaveType"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_EngDesc) }}</span>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="leaveType.EDesc"
                maxlength="50"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_ChiDesc) }}</span>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="leaveType.CDesc"
                maxlength="50"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_IsNeedUpload) }}</span>
          </b-col>
          <b-col sm="7">
            <b-form-group>
              <b-form-checkbox
                type="checkbox"
                v-model="leaveType.IsNeedUpload"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_IsPayLeave) }}</span>
          </b-col>
          <b-col sm="7">
            <b-form-group>
              <b-form-checkbox
                type="checkbox"
                v-model="leaveType.PayLeave"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_DaysAdv) }}</span>
          </b-col>
          <b-col sm="7" class="d-flex align-center">
            <b-form-input
              type="number"
              v-model="leaveType.DaysAdv"
              oninput="if(this.value < 0) this.value = 0;if(this.value > 100) this.value = 100;"
            ></b-form-input>
            {{ t.t(dictEnum.LBL_Days) }}
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters" v-if="leaveType.LeaveType==CLLV.ParamVal || leaveType.LeaveType==BDLV.ParamVal">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_TermsDays) }}</span>
          </b-col>
          <b-col sm="7" class="d-flex align-center">
            <b-form-input
              type="number"
              v-model="leaveType.Days"
              oninput="if(this.value < 0) this.value = 0;if(this.value > 100) this.value = 100;"
            ></b-form-input>
            {{ t.t(dictEnum.LBL_Days) }}
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_DiscPay) }}</span>
          </b-col>
          <b-col sm="7" class="d-flex align-center">
            <b-form-input
              type="number"
              v-model="leaveType.DiscPay"
              oninput="if(this.value < 0) this.value = 0;if(this.value > 100) this.value = 100;"
            ></b-form-input>
            %
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="5">
            <span class="bg-white">{{ t.t(dictEnum.LBL_Color) }}</span>
          </b-col>
          <b-col sm="7">
            <b-form-input v-model="leaveType.Color" type="color"></b-form-input>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MenuRightSerivce from "@/service/MenuRightService";
import LeaveTypeService from "@/service/LeaveTypeService";
import t from "@/service/SysMsgService";
import DataSyncService from "@/service/DataSyncService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import { AnnualLeaveKey, CompensationKey } from "@/constants/globalConstants";
import StoreGetter from "@/constants/StoreGetter";
import { LeaveType } from "@/model/LeaveType";
import Settings from "../../constants/Settings";
export default {
  components: {},
  computed: {
    t() {
      return t;
    }
  },

  data() {
    return {
      annualLeaveKey: AnnualLeaveKey,
      compensationKey: CompensationKey,
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_LeaveType,
      Settings: Settings,
      SysParamData: {},
      BDLV:"",
      CLLV:"",
      columns: [
        "LeaveType",
        "EDesc",
        "CDesc",
        "Color",
        "IsNeedUpload",
        "DaysAdv",
        // "PayLeave",
        "DiscPay",
        "Action"
      ],

      tableData: [],
      dictEnum: dictEnum,
      options: {
        filterable: false,
        perPageValues: [],
        sortable: [],
        skin: "table table-hover v-midle",
        headings: {
          LeaveType: "ID",
          EDesc: "Eng Description",
          CDesc: "Chi Description"
        },
        columnsClasses: {}
      },
      leaveType: new LeaveType(),
      mode: "new"
    };
  },

  methods: {
    async getSysParams() {
      const obj = {};
      const response = await DataSyncService.getSysParams(obj);
      if (response.data.IsSuccess) {
        this.SysParamData = response.data.Data;
        this.BDLV=response.data.Data.find(item => item.ParamCode === 'BDLV');
        this.CLLV=response.data.Data.find(item => item.ParamCode === 'CLLV');
      }
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    initLeaveType() {
      this.mode = "new";
      this.leaveType = new LeaveType();
    },
    onEditLeaveType(selected) {
      this.mode = "edit";
      this.leaveType = JSON.parse(JSON.stringify(selected));
    },
    async deleteLeaveType(selected) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_DeleteType)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          LeaveType: selected.LeaveType,
          UserId: this.$store.getters[StoreGetter.user].UserID
        };

        const response = await LeaveTypeService.deleteLeaveType(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },
    async editOrAddLeaveType() {
      if (!this.leaveType.LeaveType) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.MENU_LeaveType) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.leaveType.EDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.leaveType.CDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      const obj = {
        model: {
          LeaveType: this.leaveType.LeaveType,
          EDesc: this.leaveType.EDesc,
          CDesc: this.leaveType.CDesc,
          Color: this.leaveType.Color,
          IsNeedUpload: this.leaveType.IsNeedUpload,
          PayLeave: this.leaveType.PayLeave,
          DiscPay: this.leaveType.DiscPay,
          DaysAdv: this.leaveType.DaysAdv,
          Days:this.leaveType.Days,
          ModifyBy: this.$store.getters[StoreGetter.user].UserID
        }
      };

      const response =
        this.mode === "new"
          ? await LeaveTypeService.addLeaveType(obj)
          : await LeaveTypeService.updateLeaveType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDataTable() {
      const obj = {};
      const response = await LeaveTypeService.getLeaveTypes(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.tableData = response.data.Data;
      }
    }
  },

  mounted() {
    this.getSysParams();
    this.assignRights();
    this.getDataTable();

    this.options = {
      filterable: false,
      perPageValues: [],
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        LeaveType: t.t(dictEnum.MENU_LeaveType),
        EDesc: t.t(dictEnum.LBL_EngDesc),
        CDesc: t.t(dictEnum.LBL_ChiDesc),
        Color: t.t(dictEnum.LBL_Color),
        DaysAdv:t.t(dictEnum.LBL_DaysAdv),
        IsNeedUpload: t.t(dictEnum.LBL_IsNeedUpload),
        // PayLeave: t.t(dictEnum.LBL_IsPayLeave),
        DiscPay: t.t(dictEnum.LBL_DiscPay),
        Action: t.t(dictEnum.BTN_Update)
      },
      texts: {
        noResults: t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050100-LeaveType.vue